// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
export type AddressFieldsFragment = { __typename?: 'Address', street_a?: string | null, city?: string | null, state: string, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null };

export type CityAndStateFieldsFragment = { __typename?: 'Address', city?: string | null, state: string };

export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on Address {
  street_a
  city
  state
  zip
  country
  lat
  lng
  note
}
    `;
export const CityAndStateFieldsFragmentDoc = gql`
    fragment CityAndStateFields on Address {
  city
  state
}
    `;